import React from 'react'
import ListColumns from './list-columns.js'
import { filterArrayByType } from '../../utility.js'

export default ({ body }) => {
  let data = filterArrayByType(body, 'list_columns');

  if (data.length === 0) {
    return null
  }

  return (
    <React.Fragment>
      {data.map((item, index) => (
        <ListColumns 
          key={index}
          title={item.primary?.list_column_header.text}
          items={item.items}
        />
      ))}
    </React.Fragment>
  )
}
